import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import Chat from './routes/Chat';
import EmptyChatState from './components/EmptyChatState';

const MessagingLazy = React.lazy(
	() => import(/* webpackChunkName : 'Messaging' */ './Messaging')
);

export default () => [
	{
		path: 'home/messaging',
		element: (
			<AsyncLoading
				component={<MessagingLazy featureFlag="FeatureFlag:MessagingV1" />}
			/>
		),
		children: [
			{
				index: true,
				element: <AsyncLoading component={<EmptyChatState />} />,
			},
			...Chat(),
		],
	},
];
